
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QueryType } from 'enums/QueryType';
import { ExpressionFilterModel } from './Models.ExpressionFilter';
import { Model, ModelProperty } from 'models/Model';


export class DynamicQueryModel extends Model<DynamicQueryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'queryType', type: 'QueryType' },
		{ name: 'filters', type: 'ExpressionFilterModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ExpressionFilterModel }, properties: () => { return ExpressionFilterModel.classProperties } }
	];
	[key: string]: any;
	
	public queryType: QueryType;
	public filters: ExpressionFilterModel[];
    
	constructor(){
		super();
		this.queryType = 0;
		this.filters = [];
		
	}
	getProperties(){
		return DynamicQueryModel.classProperties;
	}
}

